import { createContext, useContext } from 'react'

import { AuthContextValue } from './auth-context-types'

const AuthContext = createContext<AuthContextValue | null>(null)

/**
 * Reads the current auth state and exposes auth actions. Throws if used
 * outside an AuthProvider — components must be mounted under <AuthProvider>
 * (set up in App.tsx).
 *
 * @returns {AuthContextValue}
 */
const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext)

  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}

export { AuthContext, useAuth }
